export const TERMS_URL = '/terms_and_conditions'
export const HELP_FAQ_ENTRIES_URL = '/help'
export const PRIVACY_POLICY_URL = '/privacy-policy'
export const HELP_CENTER_URL = '/help'
